// In your App.js or Router.js
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MatrimonyProfile from './Matrimonyprofile';
import AdminPanel from './AdminPanel';
import LandingPage from './LandingPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/profile" element={<MatrimonyProfile />} />
        <Route path="/admin" element={<AdminPanel />} />
      </Routes>
    </Router>
  );
}

export default App;
